<script setup lang="ts">
import { type Elemental } from '~~/src/types/elemental'
import { DropdownMenuItem } from '@/components/ui/dropdown-menu'

const { elemental, listId } = defineProps<{
  elemental: Elemental
  route: string
  listId?: string
}>()

const { duplicate, isPending } = useDuplicate(elemental, listId)

defineOptions({
  name: 'DuplicateElementalOption',
})
</script>

<template>
  <DropdownMenuItem @select="duplicate">
    <IconDuplicate class="w-3 h-3" />
    Duplicate
  </DropdownMenuItem>
  <Teleport v-if="isPending" to="body">
    <div class="absolute h-100[dvh] w-100[dvh] inset-0 z-999">
      <LoadingOverlay message="Duplicating..." />
    </div>
  </Teleport>
</template>
